import React, { ReactElement } from 'react';
import { css } from '@emotion/core';

import { SPACE_COMPACT } from '@/styles';
import { FCC } from '@/utils/types';

import ItemHeader from './item-header';

const itemStyle = css`
  & > * {
    margin: ${SPACE_COMPACT / 2}px 0;
  }
`;

const copyStyle = css`
  align-items: center;
  font-weight: 500;
`;

type ItemProps = {
  title: string | ReactElement;
} & Pick<React.HTMLProps<HTMLDivElement>, 'className'>;

const Item: FCC<ItemProps> = ({ title = 'title', className, children }) => (
  <div css={itemStyle} className={className}>
    <ItemHeader>{title}</ItemHeader>
    <div css={[copyStyle]}>{children}</div>
  </div>
);

export default Item;
